import React from 'react';
import '../styles/cultural-platform.css';

const LatestRelease = () => {
  const albumArt = "https://customer-assets.emergentagent.com/job_45a5a819-d501-49e3-92bf-1c1872263581/artifacts/f33i517k_album%20art%20ES.JPEG";
  const platformsImg = "https://customer-assets.emergentagent.com/job_45a5a819-d501-49e3-92bf-1c1872263581/artifacts/kqmy9bbq_kindpng_5011285.png";

  return (
    <div data-testid="latest-release-page">
      {/* Hero Section */}
      <section style={{
        background: '#000000',
        padding: 'clamp(48px, 6vw, 96px) 24px',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <h1 style={{
            fontFamily: 'Google Sans, Roboto, sans-serif',
            fontSize: 'clamp(36px, 5vw, 56px)',
            fontWeight: '400',
            color: '#FFFFFF',
            marginBottom: '12px'
          }}>
            Our Latest Release
          </h1>
          <p style={{
            fontFamily: 'Roboto, sans-serif',
            fontSize: 'clamp(16px, 2vw, 18px)',
            color: '#9AA0A6',
            maxWidth: '600px',
            margin: '0 auto'
          }}>
            Emaratu Salam &mdash; A UAE World Peace Song
          </p>
        </div>
      </section>

      {/* Album Art + Available On All Platforms */}
      <section style={{
        background: '#1A1A1A',
        padding: 'clamp(48px, 6vw, 80px) 24px'
      }}>
        <div style={{
          maxWidth: '1100px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '48px',
          alignItems: 'center'
        }}>
          <div style={{
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 12px 40px rgba(0, 0, 0, 0.5)'
          }}>
            <img
              src={albumArt}
              alt="Emaratu Salam - Album Art"
              data-testid="album-art"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block'
              }}
            />
          </div>
          <div style={{ textAlign: 'center' }}>
            <h2 style={{
              fontFamily: 'Google Sans, Roboto, sans-serif',
              fontSize: '18px',
              fontWeight: '600',
              color: '#FFFFFF',
              textTransform: 'uppercase',
              letterSpacing: '3px',
              marginBottom: '32px'
            }}>
              Available on All Platforms
            </h2>
            <img
              src={platformsImg}
              alt="Available on Apple Music, YouTube, Spotify, Rhapsody, Deezer, Amazon MP3, Google Play, iHeartRadio, Tidal, 7digital, Shazam, Pono, Groove, Guvera, Slacker Radio, Pandora, KKBox, Vivo and more"
              data-testid="platforms-img"
              style={{
                width: '100%',
                maxWidth: '550px',
                height: 'auto',
                display: 'block',
                margin: '0 auto'
              }}
            />
          </div>
        </div>
      </section>

      {/* YouTube Video */}
      <section style={{
        background: '#000000',
        padding: 'clamp(48px, 6vw, 80px) 24px'
      }}>
        <div style={{
          maxWidth: '900px',
          margin: '0 auto',
          textAlign: 'center'
        }}>
          <div style={{
            position: 'relative',
            width: '100%',
            paddingBottom: '56.25%',
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 12px 40px rgba(0, 0, 0, 0.5)'
          }}>
            <iframe
              src="https://www.youtube.com/embed/9Lz1wC6lUOI"
              title="Emaratu Salam - UAE World Peace Song"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              data-testid="youtube-video"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }}
            />
          </div>
        </div>
      </section>

      {/* Song Description */}
      <section style={{
        background: '#FFFFFF',
        padding: 'clamp(48px, 6vw, 96px) 24px'
      }}>
        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          fontFamily: 'Roboto, sans-serif',
          fontSize: '16px',
          lineHeight: '1.9',
          color: '#202124'
        }}>
          <p style={{ marginBottom: '24px' }}>
            Project Soft Power presents <strong>Emaratu Salam</strong> - UAE world peace song, an independent single conceptualized, composed, and produced by <strong>Leander Lee Marty</strong>.
          </p>
          <p style={{ marginBottom: '24px' }}>
            More than just a song, Emaratu Salam is a message. It reflects the values that the UAE represents to millions around the world: peace, hope, justice, vision, and humanity. Every line of the song was written with purpose, inspired by real events, conversations, emotions, and the belief that music can bring people together beyond borders, languages, and differences.
          </p>
          <p style={{ marginBottom: '24px' }}>
            Recorded across different parts of the world, Emaratu Salam brings together voices, cultures, and emotions into one shared expression. From its writing and composition to its vocals and production, the project was shaped through collaboration across countries, carrying the idea that peace is not the voice of one place alone, but of the entire world.
          </p>
          <p style={{ marginBottom: '24px' }}>
            The song is presented in Arabic and English, allowing its message to reach people everywhere while remaining deeply rooted in the identity and spirit of the UAE. With its powerful chorus and emotional storytelling, Emaratu Salam stands as both a tribute to the UAE and a reminder that even in difficult times, music can still inspire hope.
          </p>
          <p style={{
            marginBottom: '40px',
            fontStyle: 'italic',
            color: '#3C4043'
          }}>
            The song is inspired by the United Arab Emirates itself: seven Emirates united as one nation. During the creative process, a remarkable connection emerged between the UAE and music. Just as the nation is built upon seven Emirates, music is built upon seven scales. This became the foundation of the composition. Each musical scale came to represent one of the seven Emirates, carrying its own emotion, character and strength, while together forming one unified journey. Through this idea, the song was created not simply to portray the UAE as it is seen, but to allow its story, spirit and unity to be heard through music.
          </p>

          {/* Acknowledgements */}
          <div style={{
            borderTop: '1px solid #E8EAED',
            paddingTop: '40px'
          }}>
            <p style={{ marginBottom: '24px' }}>
              Project Soft Power extends its deepest respect and sincere gratitude to <strong>His Highness Sheikh Mohamed bin Zayed Al Nahyan</strong>, President of the United Arab Emirates; <strong>His Highness Sheikh Mohammed bin Rashid Al Maktoum</strong>, Vice President and Prime Minister of the UAE and Ruler of Dubai; and <strong>His Highness Sheikh Hamdan bin Mohammed bin Rashid Al Maktoum</strong>, Crown Prince of Dubai, Deputy Prime Minister, and Minister of Defence of the UAE, for their leadership, vision, and commitment to protecting the UAE and its people during this escalation.
            </p>
            <p style={{ marginBottom: '24px' }}>
              Project Soft Power sends its deepest gratitude to <strong>Shri Narendra Modi</strong>, Honourable Prime Minister of India, for his leadership, vision, and continued commitment to peace and unity between nations.
            </p>
            <p style={{ marginBottom: '24px' }}>
              We also express our sincere appreciation to <strong>His Highness Sheikh Abdullah bin Zayed Al Nahyan</strong>, Minister of Foreign Affairs of the UAE, and <strong>Dr. S. Jaishankar</strong>, Minister of External Affairs of India, whose efforts continue to strengthen the friendship between the UAE and India.
            </p>
            <p style={{ marginBottom: '40px' }}>
              Our heartfelt thanks also go to <strong>Creative Media Authority Abu Dhabi</strong> for its guidance, encouragement, and support throughout the journey of this song.
            </p>
          </div>

          {/* Closing Statement */}
          <div style={{
            borderTop: '1px solid #E8EAED',
            paddingTop: '40px',
            textAlign: 'center'
          }}>
            <p style={{
              fontSize: '17px',
              lineHeight: '2',
              color: '#3C4043',
              fontStyle: 'italic',
              marginBottom: '32px'
            }}>
              Long after the noise has faded, long after the skies are clear, and long after history has written what happened, this song will remain as a reminder:
            </p>
            <p style={{
              fontSize: '17px',
              color: '#3C4043',
              fontStyle: 'italic',
              marginBottom: '16px'
            }}>
              That when darkness came, the Emirates did not kneel.
            </p>
            <p style={{
              fontSize: 'clamp(22px, 3vw, 32px)',
              fontFamily: 'Google Sans, Roboto, sans-serif',
              fontWeight: '500',
              color: '#202124'
            }}>
              The Emirates rose!
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LatestRelease;
